import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './pages/ErrorBoundary/ErrorBoundary';
import GoogleMapsLoader from './pages/Carriers/GoogleMapsLoader';

ReactDOM.render(
  <React.Fragment>
    <ErrorBoundary>
      <GoogleMapsLoader>
        <App />
      </GoogleMapsLoader>
    </ErrorBoundary>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
